import React from 'react';
import '../styles/_legal.scss';

export default function Legal() {
    return (
        <div className="legal-page">
            <div className="legal-container">

                <div className="legal-content">
                    <section className="legal-section">
                        <h2>1. Éditeur du site</h2>
                        <div className="legal-info">
                            <p><strong>Raison sociale :</strong> Groupe MICHEL – JCM INVESTISSEMENTS</p>
                            <p><strong>Forme juridique :</strong> SA au capital de 1.760.000 €</p>
                            <p><strong>RCS :</strong> LA ROCHELLE N° 382 778 470</p>
                            <p><strong>Siège social :</strong> 161 Avenue Jean-Paul SARTRE, 17000 LA ROCHELLE</p>
                            <p><strong>Téléphone :</strong> 0800 32 16 17</p>
                            <p><strong>Email :</strong> contact@groupemichel.com</p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>2. Directeur de la publication</h2>
                        <div className="legal-info">
                            <p><strong>Raison sociale :</strong> JCM INVESTISSEMENTS</p>
                            <p><strong>Adresse :</strong> 161 Avenue Jean-Paul SARTRE, 17000 LA ROCHELLE</p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>3. Hébergement</h2>
                        <div className="legal-info">
                            <p><strong>Hébergeur :</strong> OVH</p>
                            <p><strong>Forme juridique :</strong> SAS au capital de 500 K €</p>
                            <p><strong>RCS :</strong> Roubaix – Tourcoing 424 761 419 00011</p>
                            <p><strong>Code APE :</strong> 721Z</p>
                            <p><strong>N° TVA :</strong> FR 22-424-761-419-00011</p>
                            <p><strong>Siège social :</strong> 140 Quai du Sartel, 59100 Roubaix – France</p>
                        </div>
                    </section>

                    <section className="legal-section">
                        <h2>4. Propriété intellectuelle</h2>
                        <p>
                            L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                            et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
                            les documents téléchargeables et les représentations iconographiques et photographiques.
                        </p>
                        <p>
                            La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est 
                            formellement interdite sauf autorisation expresse du directeur de la publication.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>5. Responsabilité</h2>
                        <p>
                            Les informations contenues sur ce site sont aussi précises que possible et le site remis à jour 
                            à différentes périodes de l'année, mais peut toutefois contenir des inexactitudes ou des omissions.
                        </p>
                        <p>
                            Si vous constatez une lacune, erreur ou ce qui parait être un dysfonctionnement, merci de bien 
                            vouloir le signaler par email, à l'adresse contact@groupemichel.com, en décrivant le problème de la 
                            manière la plus précise possible.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>6. Liens hypertextes</h2>
                        <p>
                            Des liens hypertextes peuvent être présents sur le site. L'utilisateur est informé qu'en 
                            cliquant sur ces liens, il sortira du site Alpine Store La Rochelle. Ce dernier n'a pas de contrôle 
                            sur les pages web sur lesquelles aboutissent ces liens et ne saurait en aucun cas être 
                            responsable de leur contenu.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>7. Droit applicable</h2>
                        <p>
                            Tout litige en relation avec l'utilisation du site Alpine Store La Rochelle est soumis au droit français. 
                            Il est fait attribution exclusive de juridiction aux tribunaux compétents de La Rochelle.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>8. Contact</h2>
                        <div className="legal-contact">
                            <p>Pour toute question concernant ces mentions légales :</p>
                            <p><strong>Email :</strong> contact@groupemichel.com</p>
                            <p><strong>Téléphone :</strong> 0800 32 16 17</p>
                            <p><strong>Adresse :</strong> 161 Avenue Jean-Paul SARTRE, 17000 LA ROCHELLE</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
